import React from 'react';
import { Switch, Route } from 'react-router-dom';
import AcervoCartograficoMunicipal from '.';

function AcervoCartograficoMunicipalRoutes() {
	return (
		<Switch>
			<Route
				path="/media/acervo-cartografico-municipal"
				component={AcervoCartograficoMunicipal}
			/>
		</Switch>
	);
}

export default AcervoCartograficoMunicipalRoutes;
